<template>
  <div>
    <!--    面包屑-->
    <header class="header">
      <div style="position: absolute;left: 16px;top: 17px;font-weight: bolder">用户权限管理</div>
    </header>

    <!--    表格-->
    <main class="main">
      <header>
        <section>
          用户权限
        </section>
        <section class="main-header-search">
          <el-autocomplete
              v-model="userSearchForm.userId"
              :fetch-suggestions="usernameSuggestions"
              value-key="name"
              @select="handleSearchUser"
              @change="searchUsernameChange"
              placeholder="请输入要查询的用户名">
          </el-autocomplete>
        </section>
      </header>

      <!--      表格主体-->
      <article
          class="table"
          v-loading="loadingUserListData">
        <el-table
            :empty-text="'没有数据'"
            :data="userListData"
            :fit="true"
            style="width: 100%">
          <el-table-column
              type="index"
              label="序号"
              :index="indexMethod" width="90px">
          </el-table-column>
          <el-table-column
              prop="name"
              label="用户名">
            <template #default="scope">
              <div> {{ scope.row.realname }} ({{scope.row.username }})</div>
            </template>
          </el-table-column>
          <el-table-column
              prop="authoritiesString"
              label="权限">
          </el-table-column>
          <el-table-column
              label="操作">
            <template slot-scope="scope">
              <el-link type="primary" @click="openAuthorityDialog(scope.row)">修改权限</el-link>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog :title="userForm.username+'的权限管理'" :visible.sync="authorityDialogVisible" width="25%">
          <el-form :model="userForm">
            <el-form-item label="权限">
              <el-select v-model="userForm.authorityType" placeholder="请选择">
                <el-option
                    v-for="item in authorityOption"
                    :key="item.en"
                    :label="item.ch"
                    :value="item.en">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="authorityDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="modifyAuthority">确 定</el-button>
          </div>
        </el-dialog>
      </article>

      <!--      分页-->
      <footer class="main-footer">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :current-page="pageData.currentPage"
            :page-sizes="[10, 15]"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.totalElements">
        </el-pagination>
      </footer>
    </main>
  </div>
</template>

<script>
import {findAllUser, modifyAuthorityType, findSimilarUsername} from "@/api/User";
import {Message} from "element-ui";
import {ParseAuthorityEn2Ch} from "@/utils/common";

function User(id, username, realname, authorities) {
  this.id = id;
  this.username = username;
  this.realname = realname ?? "";
  this.authorityType = authorities[0].authorityType;
  this.authorities = authorities;
  this.authoritiesString = ParseAuthorityEn2Ch(this.authorityType);
}

export default {
  name: "UserList",
  mounted() {
    this.loadUsers()
  },
  data() {
    return {
      loadingUserListData: false,
      userListData: [],
      userSearchForm:{
        userId:undefined
      },
      // 在操作中使用（修改权限等操作）
      userForm: [],
      pageData: {
        currentPage: 1,
        totalPages: undefined,
        pageSize: 10,
        totalElements: undefined
      },
      authorityDialogVisible: false,
      authorityOption: [
        {en: "ROLE_SUPER_ADMIN", ch: "系统管理员"},
        {en: "ROLE_APP_ADMIN", ch: "应用管理员"},
        {en: "ROLE_USER", ch: "用户"},
      ]
    }
  },
  methods: {
    loadUsers(pageNumber = 1, pageSize = 10,userId) {
      this.loadingUserListData = true;
      findAllUser(pageNumber, pageSize,userId).then(res => {
        this.userListData = []
        res.data.content.forEach(e => {
          let user = new User(e.id, e.username, e.realName, e.authorities)
          this.userListData.push(user)
        })
        this.pageData.currentPage = res.data.number + 1;
        this.pageData.totalPages = res.data.totalPages;
        this.pageData.pageSize = res.data.size;
        this.pageData.totalElements = res.data.totalElements;
        this.loadingUserListData = false;
      }).catch(() => {
        this.loadingUserListData = false;
      })
    },
    indexMethod(index) {
      return index + 1
    },
    // 操作-权限操作
    openAuthorityDialog(row) {
      this.userForm = row
      this.authorityDialogVisible = true
    },
    modifyAuthority() {
      modifyAuthorityType(this.userForm.id, this.userForm.authorityType).then(() => {
        Message({
          message: "成功修改用户权限",
          type: 'success',
          duration: 3 * 1000
        })
      })
      setTimeout(()=>{
        this.loadUsers()
        this.authorityDialogVisible = false;
      },100)
    },
    handleCurrentPageChange(val) {
      this.loadUsers(val, this.pageData.pageSize)
    },
    handleSizeChange(val) {
      this.loadUsers(this.pageData.currentPage, val)
    },
    usernameSuggestions(queryString, cb) {
      findSimilarUsername(queryString).then(res => {
        if(res.data) {
          res.data.forEach((i) => {
            i.name = i.realname ? i.realname + '('+i.username+')' : i.username
          })
        }
        cb(res.data)
      })
    },
    handleSearchUser(item) {
      this.loadUsers(1,this.pageData.pageSize,item.id)
    },
    searchUsernameChange(data) {
      if (data === '') {
        this.loadUsers(this.pageData.currentPage,this.pageData.pageSize)
      }
    }
  }
}
</script>

<style scoped>
.header {
  width: 100%;
  height: 56px;
  background: #f4f9ff;
}

.main {
  margin: 12px 16px;
  background: #ffffff;
  border-radius: 4px;
  min-height: calc(100vh - 44px - 56px - 24px - 50px);
  padding: 22px 32px;
  position: relative;
}

.table {
  margin-top: 20px;
}

.main-footer {
  position: absolute;
  bottom: 24px;
  left: calc(50% - 263px);
}

.main-header-search {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
